import React from 'react'
import {FieldFormElementProps} from "../../../render/form-elemnent";
import FieldAttachment_FormElementView from "./form-element-view";

const debug = false
// const debug = "FieldAttachment_FormElement"

export default function FieldAttachment_FormElement(props:FieldFormElementProps) {

    const onChange = (value: any) => {

        if (props.form) {
            props.form.onFormComponentValueChange(props.field.fieldId, value)
        }
    }

    return (
        <FieldAttachment_FormElementView   field     = {props.field}
                                           model     = {props.model}
                                           onChange  = {onChange}
                                           className = {props.className} />
    )

}
